import Background from '@components/atoms/images/background';
import BackgroundMask from '@components/atoms/mask/backgroundMask';
import ChannelListBackgroundContainer from '@components/atoms/container/channelListBackgroundContainer';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import { useContext, useEffect, useState } from 'react';

const SHOW_BACKGROUND_TIME = 450;

export default function ChannelListBackground() {
  const { event } = useContext(ChannelListContext);
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    setDisplay(false);
    const imageTimeout = setTimeout(() => {
      setDisplay(true);
    }, SHOW_BACKGROUND_TIME);

    return () => {
      clearTimeout(imageTimeout);
    };
  }, [event?.background]);

  return (
    <ChannelListBackgroundContainer>
      {display ? <Background src={event?.background} /> : null}
      <BackgroundMask id={'backgroundMask'} />
    </ChannelListBackgroundContainer>
  );
}
